// const { result, error } = mapArrayToObject([]);
export function mapArrayToObject(array, keyProperty = "id", valueProperty = null) {
  const result = {};

  if (!Array.isArray(array)) {
    return {
      result: null,
      error: "The first argument must be an array."
    };
  }

  for (const item of array) {
    if (typeof item !== "object" || item === null) {
      return {
        result: null,
        error: "Each item in the array must be a non-null object."
      };
    }

    // Check if the keyProperty exists in the item
    if (!(keyProperty in item)) {
      return {
        result: null,
        error: `Key property "${keyProperty}" is not found in one of the items.`
      };
    }

    const key = item[keyProperty];
    const value = valueProperty ? item[valueProperty] : item;

    // Check for duplicate keys
    if (key in result) {
      return {
        result: null,
        error: `Duplicate key "${key}" found. Ensure all keys are unique.`
      };
    }

    result[key] = value;
  }

  return {
    result,
    error: null
  };
}

// const { result, error } = searchArray(data, searchTerm, searchKeys);
export function searchArray(array = [], searchTerm = "", searchKeys = []) {
  let errorMessages = [];

  if (!Array.isArray(array)) {
    errorMessages.push("The first argument must be an array.");
  }
  if (typeof searchTerm !== "string") {
    errorMessages.push("The search term must be a string.");
  }
  if (!Array.isArray(searchKeys)) {
    errorMessages.push("The search keys must be an array.");
  } else if (searchKeys.length === 0) {
    errorMessages.push("The search keys array must contain at least one key.");
  }

  if (errorMessages.length > 0) {
    return { result: null, error: errorMessages.join("\n") };
  }

  const term = searchTerm.toLowerCase();

  const result = array.filter((item) => {
    return searchKeys.some((key) => {
      // Check if item has the key and its value includes the searchTerm
      return hasOwn(item, key) && String(item[key]).toLowerCase().includes(term);
    });
  });

  return { result, error: null };
}

export function groupByKey(array, key, ignoreMissingKey = false) {
  if (typeof array !== "object" || array === null) {
    return { result: null, error: "The first argument must be an array." };
  }

  if (typeof key !== "string" || key.length === 0) {
    return { result: null, error: "The key must be a non-empty string." };
  }

  const result = {};

  let i = 0;
  while (i < array.length) {
    const item = array[i];

    if (typeof item !== "object" || item === null) {
      return { result: null, error: "Each item in the array must be a non-null object." };
    }

    if (item[key] === undefined) {
      if (ignoreMissingKey) {
        i++;
        continue;
      } else {
        return { result: null, error: `Key "${key}" is missing in some items.` };
      }
    }

    const keyValue = item[key];

    if (result[keyValue] === undefined) {
      result[keyValue] = [];
    }

    const length = result[keyValue].length;
    result[keyValue][length] = item;

    i++;
  }

  return { result, error: null };
}

export function debounce(func, delay) {
  let timer = null;

  function debounced(...args) {
    const context = this;

    if (timer !== null) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  }

  debounced.cancel = () => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return debounced;
}

export const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
